// Libraries
import { DateTime } from "luxon";

// Constants
import { MANITOBA_TIMEZONE } from "Constants/TimeConstants";

export const hasAppointmentTimePassed = (date, time) => {
  const appointmentTime = DateTime.fromFormat(
    `${date} ${time}`,
    "yyyy-MM-dd hh:mm a"
  ).setZone(MANITOBA_TIMEZONE, { keepLocalTime: true });

  return appointmentTime < DateTime.now().setZone(MANITOBA_TIMEZONE);
};
